import React from 'react';
import { Mail, FileText } from 'lucide-react';
import { toast } from 'sonner';
import { auth } from '../../utils/auth';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const LeadActions = ({
  lead, setLead, updateLead, updating,
  showEmailForm, setShowEmailForm, emailData, setEmailData, sendPartnerEmail,
  convertToRegularLead, converting,
  showDeleteModal, setShowDeleteModal, deletePlz, setDeletePlz, deleteLead, deleting,
  navigate, t
}) => {
  return (
    <>
      {/* Lead Management */}
      <div className="admin-card">
        <h2 style={{ fontSize: '1.25rem', fontWeight: '600', marginBottom: '1.5rem' }}>Lead-Management</h2>
        
        {lead.status === 'waitlist' && (
          <div style={{ marginBottom: '1.5rem', padding: '1rem', background: '#FFF9E6', borderRadius: '8px', border: '2px solid #F57C00' }}>
            <h3 style={{ fontSize: '1rem', fontWeight: '600', color: '#E65100', marginBottom: '0.5rem' }}>Wartelisten-Eintrag</h3>
            <p style={{ fontSize: '0.875rem', color: '#666', marginBottom: '1rem' }}>Dieser Lead ist ein Wartelisten-Eintrag.</p>
            <button onClick={convertToRegularLead} disabled={converting} className="btn-primary" style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }} data-testid="convert-to-regular-btn">
              {converting ? 'Wird umgewandelt...' : 'In regulären Lead umwandeln'}
            </button>
          </div>
        )}

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '1rem', marginBottom: '1.5rem' }}>
          <div>
            <label className="form-label">Status</label>
            <select value={lead.status} onChange={(e) => updateLead({ status: e.target.value })} className="form-select" disabled={updating} data-testid="status-select">
              <option value="neu">Neu</option>
              <option value="contacted">Kontaktiert</option>
              <option value="weitergeleitet">Weitergeleitet</option>
              <option value="qualified">konkret Planen</option>
              <option value="converted">in Umsetzung</option>
              <option value="rejected">on Hold</option>
              <option value="delete">Lead löschen</option>
              <option value="waitlist">Warteliste</option>
            </select>
          </div>
          <div>
            <label className="form-label">Zugewiesener Partner</label>
            <input type="text" value={lead.assigned_partner || ''} onChange={(e) => setLead({ ...lead, assigned_partner: e.target.value })} onBlur={(e) => updateLead({ assigned_partner: e.target.value })} className="form-input" placeholder="Partner-Name oder Firma" data-testid="partner-input" />
          </div>
        </div>
        <div>
          <label className="form-label">Notizen</label>
          <textarea value={lead.notes || ''} onChange={(e) => setLead({ ...lead, notes: e.target.value })} onBlur={(e) => updateLead({ notes: e.target.value })} className="form-input" rows="4" placeholder="Interne Notizen..." data-testid="notes-textarea" />
        </div>
      </div>

      {/* Email to Partner */}
      <div className="admin-card">
        <h2 style={{ fontSize: '1.25rem', fontWeight: '600', marginBottom: '1.5rem' }}>An Partner weiterleiten</h2>
        {!showEmailForm ? (
          <button onClick={() => setShowEmailForm(true)} className="btn-primary" style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }} data-testid="show-email-form-btn">
            <Mail size={18} /> Lead per E-Mail weiterleiten
          </button>
        ) : (
          <div>
            <div className="form-group">
              <label className="form-label">Partner E-Mail*</label>
              <input type="email" value={emailData.partner_email} onChange={(e) => setEmailData({ ...emailData, partner_email: e.target.value })} className="form-input" placeholder="partner@example.com" data-testid="partner-email-input" />
            </div>
            <div className="form-group">
              <label className="form-label">Nachname des Partners*</label>
              <input type="text" value={emailData.partner_lastname} onChange={(e) => setEmailData({ ...emailData, partner_lastname: e.target.value })} className="form-input" placeholder="z.B. Müller" data-testid="partner-lastname-input" />
            </div>
            <div className="form-group">
              <label className="form-label">Anrede*</label>
              <div style={{ display: 'flex', gap: '1rem' }}>
                <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', cursor: 'pointer' }}>
                  <input type="radio" name="partner_gender" value="male" checked={emailData.partner_gender === 'male'} onChange={(e) => setEmailData({ ...emailData, partner_gender: e.target.value })} data-testid="partner-gender-male" />
                  <span>Herr</span>
                </label>
                <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', cursor: 'pointer' }}>
                  <input type="radio" name="partner_gender" value="female" checked={emailData.partner_gender === 'female'} onChange={(e) => setEmailData({ ...emailData, partner_gender: e.target.value })} data-testid="partner-gender-female" />
                  <span>Frau</span>
                </label>
              </div>
            </div>
            <div style={{ display: 'flex', gap: '1rem' }}>
              <button onClick={sendPartnerEmail} className="btn-primary" disabled={!emailData.partner_email || !emailData.partner_lastname} data-testid="send-partner-email-btn">E-Mail senden</button>
              <button onClick={() => setShowEmailForm(false)} className="btn-secondary" data-testid="cancel-email-btn">Abbrechen</button>
            </div>
          </div>
        )}
      </div>

      {/* Delete Lead */}
      <div className="admin-card" style={{ border: '2px solid #D32F2F' }}>
        <h2 style={{ fontSize: '1.25rem', fontWeight: '600', marginBottom: '1rem', color: '#D32F2F' }}>Gefahrenzone</h2>
        <p style={{ fontSize: '0.875rem', color: '#666', marginBottom: '1rem' }}>Achtung: Das Löschen eines Leads kann nicht rückgängig gemacht werden.</p>
        {!showDeleteModal ? (
          <button onClick={() => setShowDeleteModal(true)} className="btn-secondary" style={{ background: '#D32F2F', color: 'white', border: 'none' }} data-testid="show-delete-btn">Lead löschen</button>
        ) : (
          <div style={{ padding: '1rem', background: '#FFEBEE', borderRadius: '8px' }}>
            <h3 style={{ fontSize: '1rem', fontWeight: '600', marginBottom: '1rem', color: '#D32F2F' }}>Lead wirklich löschen?</h3>
            <p style={{ fontSize: '0.875rem', marginBottom: '1rem' }}>Bitte geben Sie die PLZ dieses Leads zur Bestätigung ein: <strong>{lead.plz}</strong></p>
            <div className="form-group" style={{ marginBottom: '1rem' }}>
              <input type="text" value={deletePlz} onChange={(e) => setDeletePlz(e.target.value)} placeholder="PLZ zur Bestätigung" className="form-input" data-testid="delete-plz-input" />
            </div>
            <div style={{ display: 'flex', gap: '1rem' }}>
              <button onClick={deleteLead} disabled={deleting || deletePlz !== lead.plz} className="btn-primary" style={{ background: '#D32F2F', border: 'none' }} data-testid="confirm-delete-btn">
                {deleting ? 'Wird gelöscht...' : 'Endgültig löschen'}
              </button>
              <button onClick={() => { setShowDeleteModal(false); setDeletePlz(''); }} className="btn-secondary" data-testid="cancel-delete-btn">Abbrechen</button>
            </div>
          </div>
        )}
      </div>

      {/* Files */}
      {((lead.file_uploads && lead.file_uploads.length > 0) || (lead.file_paths && lead.file_paths.length > 0)) && (
        <div className="admin-card">
          <h2 style={{ fontSize: '1.25rem', fontWeight: '600', marginBottom: '1.5rem' }}>
            Hochgeladene Dateien ({lead.file_uploads ? lead.file_uploads.length : lead.file_paths.length})
          </h2>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
            {(lead.file_uploads && lead.file_uploads.length > 0 ? lead.file_uploads : 
              lead.file_paths.map(path => {
                const filename = path.split('/').pop();
                const fileId = filename.split('.')[0];
                const extension = filename.split('.').pop().toLowerCase();
                return { id: fileId, original_name: filename, extension };
              })
            ).map((upload, index) => {
              const fileId = upload.id;
              const filename = upload.original_name;
              const extension = upload.extension.toLowerCase().replace('.', '');
              const isImage = ['jpg', 'jpeg', 'png'].includes(extension);
              return (
                <div key={index} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '0.5rem', padding: '0.75rem 1rem', background: '#F5F5F5', borderRadius: '8px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                    <FileText size={18} style={{ color: extension === 'pdf' ? '#E53935' : '#4CAF50' }} />
                    <span style={{ fontWeight: '500' }}>{filename}</span>
                    <span style={{ fontSize: '0.75rem', color: '#666', textTransform: 'uppercase' }}>({extension})</span>
                  </div>
                  <a href="#" style={{ display: 'inline-flex', alignItems: 'center', gap: '0.25rem', padding: '0.5rem 1rem', background: '#4CAF50', color: 'white', borderRadius: '6px', textDecoration: 'none', fontSize: '0.875rem', fontWeight: '500' }}
                    onClick={(e) => {
                      e.preventDefault();
                      const token = auth.getToken();
                      if (!token) { toast.error(t('toastReloginRequired')); navigate('/admin/login'); return; }
                      fetch(`${API}/leads/${lead.id}/files/${fileId}`, { headers: { 'Authorization': `Bearer ${token}` } })
                        .then(r => { if (!r.ok) throw new Error(`HTTP ${r.status}`); return r.blob(); })
                        .then(blob => { const url = window.URL.createObjectURL(blob); const a = document.createElement('a'); a.href = url; a.download = filename; document.body.appendChild(a); a.click(); window.URL.revokeObjectURL(url); a.remove(); })
                        .catch(() => toast.error(t('toastFileDownloadError')));
                    }}
                  >
                    {isImage ? '📷 Anzeigen' : '📥 Herunterladen'}
                  </a>
                </div>
              );
            })}
          </div>
          <p style={{ fontSize: '0.75rem', color: '#666', marginTop: '1rem' }}>
            💡 Diese Dateien werden automatisch als Anhang an Partner weitergeleitet.
          </p>
        </div>
      )}
    </>
  );
};

export default LeadActions;
